import {lazy} from 'react';

export const TextSizeLazy = lazy(() => import(/* webpackChunkName: "textSize" */ '.'));
